import QuestionLayout from "./QuestionLayout";

function normalizeStepInput(input) {
  if (!input) return "";

  return input.trim().toUpperCase();
}

export default function HalfWholeStepsWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  function updateStep(id, nextValue) {
    onChange({
      ...value,
      [id]: normalizeStepInput(nextValue)
    });
  }

  function stepFeedback(id) {
    return feedback?.parts?.[id] ?? null;
  }

  return (
    <QuestionLayout
  number={config.number}
  prompt={config.prompt}
  points={config.points}
  mode={mode}
  feedback={feedback}
>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 16
    }}
  >
    {config.scaleTitle && (
      <div
        style={{
          fontSize: 20,
          fontWeight: "bold"
        }}
      >
        {config.scaleTitle}
      </div>
    )}

    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "visible"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
          width: "max-content",
          minWidth: "100%",
          justifyContent: "center",
          gap: 8,
          padding: "2px 4px 6px",
          fontSize: 18
        }}
      >
        {(config.notes || []).map((note, index) => {
          const step = config.steps?.[index];
          const fb = step ? stepFeedback(step.id) : null;

          return (
            <div
              key={`${note}-${index}`}
              style={{
                display: "flex",
                alignItems: "center",
                flex: "0 0 auto",
                gap: 8
              }}
            >
              <span
                style={{
                  fontSize: 20,
                  fontWeight: "bold",
                  minWidth: 28,
                  textAlign: "center"
                }}
              >
                {note}
              </span>

              {step && (
                <input
                  type="text"
                  maxLength={1}
                  value={value[step.id] || ""}
                  disabled={mode !== "edit"}
                  onChange={(e) => updateStep(step.id, e.target.value)}
                  style={{
                    width: 34,
                    fontSize: 16,
                    textAlign: "center",
                    padding: "6px 4px",
                    borderRadius: 6,
                    textTransform: "uppercase",
                    border:
                      mode === "review"
                        ? fb?.correct
                          ? "2px solid #2e7d32"
                          : "2px solid #c62828"
                        : "1px solid #aaa"
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  </div>
</QuestionLayout>
  );
}